import { useState } from 'react';
import { favoritesService } from '../lib/favorites/favoritesService';
import { useAnalytics } from './useAnalytics';
import { useSection } from './useSection';

interface UseFavoriteToggleOptions {
  itemId: string;
  itemName: string;
  category?: string;
  type?: string;
  sectionType: string;
  itemData: any;
}

export function useFavoriteToggle({
  itemId,
  itemName,
  category,
  type,
  sectionType,
  itemData
}: UseFavoriteToggleOptions) {
  const section = useSection();
  const [isFavorite, setIsFavorite] = useState(() => favoritesService.isFavorite(itemId));

  const analytics = useAnalytics({
    sectionId: section.id,
    sectionName: section.names.fr,
    sectionType
  });

  const handleFavoriteToggle = async (newState: boolean) => {
    try {
      if (newState) {
        favoritesService.addFavorite({
          id: itemId,
          sourceType: sectionType,
          data: itemData,
          metadata: {
            sourceSection: {
              id: section.id,
              type_rubrique: sectionType,
              names: section.names
            },
            sectionSlug: section.names.fr,
            sectionNames: section.names,
            item_id: itemId,
            section_id: section.id
          }
        });

        analytics.trackItemAction(itemId, 'add_favorite', sectionType, {
          item_name: itemName,
          category,
          type
        });
      } else {
        favoritesService.removeFavorite(itemId);

        analytics.trackItemAction(itemId, 'remove_favorite', sectionType, {
          item_name: itemName,
          category,
          type
        });
      }
      setIsFavorite(newState);
    } catch (error) {
      analytics.trackError('favorite_toggle_error', error as Error, {
        item_id: itemId,
        item_name: itemName,
        action: newState ? 'add' : 'remove'
      });
    }
  };

  return { isFavorite, handleFavoriteToggle };
}
